import { Route, Routes } from 'react-router-dom';
import { useState } from 'react';
import Snowfall from 'react-snowfall';

import Home from './components/Pages/Home';
import About from './components/Pages/About';
import Skills from './components/Pages/Skills';
import Projects from './components/Pages/Projects';
import Contact from './components/Pages/Contact';
import NavBar from './components/NavBar/NavBar';
import SocialMedia from './components/SocialMedia/SocialMedia';
import Snow from './components/Snow';

import './styles.css';

function App() {
  const [stateSnow, setStateSnow] = useState(true);
  const activeSnow = () => {
    stateSnow ? setStateSnow(false) : setStateSnow(true);
  };

  return (
    <div className="body-container">
      {stateSnow ? <Snowfall snowflakeCount={20} /> : ''}
      <SocialMedia />
      <Snow onClick={activeSnow} stateSnow={stateSnow} />
      <div className="main-container">
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </div>

        <NavBar />
      </div>
    </div>
  );
}

export default App;
